import { isNumber } from "lodash";

import type { Order } from "../../../../../../../services";
import type { DateFns } from "../../../../../../../utils/DateFns";

const cellProcessing = (item: Order.Model, dateFns: DateFns): string => {
	const executorArrivalTimestamp =
		item?.executorToOrder?.[0]?.additionalFields?.arrivalTime ||
		item?.additionalFields?.transfer?.lastReceivedOrder
			?.executorToOrder?.[0]?.additionalFields?.arrivalTime;

	if (!isNumber(executorArrivalTimestamp)) return "";

	return dateFns.formatTime2(executorArrivalTimestamp, "dd-MM-yyyy");
};

export default cellProcessing;
